import React from 'react'
import { Flex, Row } from 'antd'
import { StyledBoxProps, StyledRowProps } from './types'

export const StyledBox: React.FC<StyledBoxProps> = ({children, style={}}) => (
    <Flex
        vertical
        style={{
            backgroundColor: '#ffcc80',
            borderRadius: '4px',
            padding: '5px 5px',
            height: '100%',
            gap: '6px',
            alignItems: 'center',
            ...style,
        }}
     >
        {children}
    </Flex>
)

export const StyledRow: React.FC<StyledRowProps> = ({children, offset, style={}}) => (
    <Row
        gutter={[offset, offset]}
        style={{
            // marginBlock: `${offset}px`,
            // marginLeft: '0px',
            // marginRight: '0px',
            ...style
        }}
    >
        {children}
    </Row>
)
